import { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';

interface MainContextValue {
  scrollable: boolean;
  setScrollable: (value: boolean) => void;
}

export const MainContext = createContext<MainContextValue>({
  scrollable: false,
  setScrollable: () => {},
});

export function MainProvider({ children }: { children: ReactNode }) {
  const [scrollable, setScrollable] = useState(false);
  return (
    <MainContext value={{ scrollable, setScrollable }}>
      {children}
    </MainContext>
  );
}

export function useMainContext() {
  return useContext(MainContext);
}
